import React, { useState } from 'react';

const PagerForm = () => {
  const [formData, setFormData] = useState({
    channel_name: '',
    user_name: ''
  });
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setMessage('');

    const url = 'https://b9fcg6y884.execute-api.us-east-1.amazonaws.com/production/page';
    const encoded = new URLSearchParams(formData).toString();

    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encoded
      });

      const data = await res.json();
      setStatus(res.ok ? 'success' : 'error');
      setMessage(data.text || data.message || 'Unexpected response');
    } catch (err) {
      setStatus('error');
      setMessage(err.message);
    }
  };

  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f6f6f6',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
        padding: '1rem'
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          maxWidth: '480px',
          width: '100%'
        }}
      >
        <h2 style={{ marginBottom: '1.5rem', color: '#333' }}>
          Trigger Pager Alert
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
              Company Name
            </label>
            <input
              type="text"
              name="channel_name"
              value={formData.channel_name}
              onChange={handleChange}
              placeholder="Rimble Customer 1"
              required
              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid #ccc',
                borderRadius: '4px'
              }}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
              Your Name
            </label>
            <input
              type="text"
              name="user_name"
              value={formData.user_name}
              onChange={handleChange}
              placeholder="john_doe"
              required
              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid #ccc',
                borderRadius: '4px'
              }}
            />
          </div>

          <button
            type="submit"
            style={{
              width: '100%',
              backgroundColor: '#0066cc',
              color: '#fff',
              padding: '0.75rem',
              border: 'none',
              borderRadius: '4px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Trigger Pager for Rimble Support
          </button>
        </form>

        {status && (
          <div
            style={{
              marginTop: '1rem',
              padding: '1rem',
              backgroundColor: status === 'success' ? '#d4edda' : '#f8d7da',
              color: status === 'success' ? '#155724' : '#721c24',
              borderRadius: '5px',
              border: `1px solid ${status === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                marginRight: '10px',
                fontSize: '1.25rem',
                fontWeight: 'bold',
              }}
            >
              {status === 'success' ? '✔️' : '❌'}
            </span>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default PagerForm;
